var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-button',{attrs:{"type":_vm.is_dead ? 'danger' : 'primary',"size":"small","ghost":""},on:{"click":_vm.to_detail_page}},[_vm._v(_vm._s(_vm.text && _vm.text.length > 0 ? _vm.text : ("id:" + _vm.id)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }